/* eslint-disable import/prefer-default-export */
export const GET_LEAD_REQUEST = 'GET_LEAD_REQUEST';
